import { SELLER_STATUS_APPROVED, SELLER_STATUS_IN_DISPUTE, GRN_OR_FILTER_VALUES } from "../../../utils/constants/others";
import { strings } from "utils/constants/strings";


export const DEFAULT_OR_FILTERS = [GRN_OR_FILTER_VALUES.SELLER_STATUS_NON_APPROVED];

export const GRN_OR_FILTERS = [
    {
        label: strings.grnFilterConfirmationPending,
        value: GRN_OR_FILTER_VALUES.SELLER_STATUS_NON_APPROVED,
    },
    {
        label: strings.grnFilterConfirmed,
        value: GRN_OR_FILTER_VALUES.SELLER_STATUS_APPROVED,
    },
    {
        label: strings.grnFilterInDispute,
        value: GRN_OR_FILTER_VALUES.SELLER_STATUS_IN_DISPUTE,
    },
    {
        label: strings.grnFilterPaid,
        value: GRN_OR_FILTER_VALUES.PAYMENT_STATUS_PAID,
    },
];

export function isInvoiceNumberValid(invoiceNumber) {
    if (invoiceNumber?.length <= 0) {
        return true
    }

    const invoiceNumberRegex = /^[0-9a-zA-Z/\-\\.#_()|&]{1,50}$/;
    return invoiceNumberRegex.test(invoiceNumber);
}

export function isGrnSellerStatusApproved(sellerStatus) {
    return SELLER_STATUS_APPROVED == sellerStatus || SELLER_STATUS_IN_DISPUTE == sellerStatus
}
